import './rateCard.css';
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { getItemTypeList, getUrnsList, getAllRouteDetails, getRateUnits, rateCardValidity } from './rateCardAPIs';
import { getAllState, getAllDistrict, getAllRevenueCircle, getCategoryList } from '../resourceCommonAPIs';
import { CATEGORY_ERROR, ITEM_TYPE_ERROR, STATE_ERROR, DISTRICT_ERROR, REVENUE_CIRCLE_ERROR, ROUTE_TYPE_ERROR, UNIT_PER_ERROR, CREATE_RATE_CARD, STAKEHOLDER_URN, STAKEHOLDER_NAME, REGISTRATION_NO, VEHICLE_TYPE, VEHICLE_CAPACITY, VEHICLE_MAKE, VEHICLE_MODEL, ROUTE, LAND_NAME, ITEM_RATE, SUBMIT, CATEGORY, ITEM_TYPE, ROUTE_TYPE, STATE, DISTRICT, REVENUE_CIRCLE, UNIT_PER, ITEM_RATE_MASS_ENTRY, INSERT_ALL, NO_DATA_AVAILABLE, PROCEED, FILE_NAME_VALIDATION_ERROR } from '../../../common/constants';
import { handleNumberFieldFocus, titleCase } from '../../../common/commonFunction';
import { Button, CardContent } from '@mui/material';
import { PROD } from '../../../common/constants';
import { Container, Card, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DataGrid } from '@mui/x-data-grid';
import BackButton from '../../../common/backButton';
import { DistrictChangePopover } from './districtChangePopover';
import { fileNameValidation, validateAmount } from '../../../common/commonValidations';
import { v4 as uuidv4 } from 'uuid';
import * as XLSX from 'xlsx';
import { Download as DownloadIcon } from '@mui/icons-material';
import { RATE_CARD_MASS_ENTRY } from '../../../common/URLs';
import dayjs from 'dayjs';


import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { ProceedIcon, UploadIcon } from '../../../common/icons';
import apiClient from '../../../axios';
import moment from 'moment';

function RateCardMassEntry() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [categoryList, setCategoryList] = useState();
    const [itemTypeList, setItemTypeList] = useState();
    const [showData, setShowData] = useState(state?.category ? true : false);
    const [onChangeFlag, setOnChangeFlag] = useState(false);
    const [urnsList, setUrnsList] = useState(state?.urnsList && state?.urnsList);
    const [routesList, setRoutesList] = useState();
    const [chooseState, setchooseState] = useState([]);
    const [chooseDistrict, setChooseDistrict] = useState([]);
    const [chooseRevenueCircle, setChooseRevenueCircle] = useState([]);
    const [unitsList, setUnitsList] = useState([]);
    const [checkValidityResponse, setCheckValidityResponse] = useState();
    const [failedRateCardArr, setFailedRateCardArr] = useState();
    const [distrcitLogModalOpen, setDistrcitLogModalOpen] = useState(false);
    const handleDistrictLogModalOpen = () => setDistrcitLogModalOpen(true);
    const handleDistrictLogModalClose = () => setDistrcitLogModalOpen(false);
    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
    const [selectedFile, setSelectedFile] = useState();
    const extensionList = ['xls', 'xlsx', 'xlsm'];
    const [fileuploadError, setFileuploadError] = useState('');
    const [uploadDetails, setUploadDetails] = useState();
    const [budgetApprovalRole, setBudgetApprovalRole] = useState();
    const [rateCardDetails, setRateCardDetails] = useState(
        {
            category: state?.category ? state?.category : null,
            itemType: state?.itemType ? state?.itemType : null,
            unitPer: state?.unitPer ? state?.unitPer : null,
            validFromProceed: state?.validFromProceed ? state?.validFromProceed : null,
            validToProceed: state?.validToProceed ? state?.validToProceed : null,
            validFrom: state?.validFrom ? state?.validFrom : null,
            validTo: state?.validTo ? state?.validTo : null,
            itemRate: state?.itemRate ? state?.itemRate : null,
            routeType: state?.routeType ? state?.routeType : null,
            state: state?.state ? state?.state : null,
            district: state?.district ? state?.district : null,
            revenueCircle: state?.revenueCircle ? state?.revenueCircle : null,
        }
    );
    const [errorMessage, setErrorMessage] = useState({
        categoryError: '',
        itemTypeError: '',
        unitPerError: '',
        itemRateError: '',
        validFromError: '',
        validToError: '',
        validFromProceedError: '',
        validToProceedError: '',
        routeTypeError: '',
        stateError: '',
        districtError: '',
        addItemError: ''
    });
    const [rateCardDetailsArr, setRateCardDetailsArr] = useState(state?.rateCardDetailsArr ? state?.rateCardDetailsArr : []);
    const [finalRateCardDetailsArr, setFinalRateCardDetailsArr] = useState(state?.finalRateCardDetailsArr && state?.finalRateCardDetailsArr);
    const [addedRateCardDetailsArr, setAddedRateCardDetailsArr] = useState(state?.addedRateCardDetailsArr ? state?.addedRateCardDetailsArr : []);
    const [filteredRateCardDetailsArr, setFilteredRateCardDetailsArr] = useState();
    const [filterTable, setFilterTable] = useState({
        urnNumber: '',
        name: ''
    });
    const [submit, setSubmit] = useState(false);
    useEffect(() => {
        getCategoryList(setCategoryList);
        getItemTypeList(setItemTypeList);
        getAllRouteDetails(setRoutesList);
        getAllState(setchooseState);
        getRateUnits(setUnitsList);
    }, []);

    useEffect(() => {
        if (urnsList && onChangeFlag) {
            let arrayData = []
            urnsList?.map((item) => {
                if (rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") {
                    item?.vehicleList?.map((vehicleList) => arrayData.push({
                        id: uuidv4(),
                        category: rateCardDetails?.category,
                        itemType: rateCardDetails?.itemType,
                        unitPer: rateCardDetails?.unitPer,
                        urnNumber: item?.urn,
                        name: item?.name,
                        state: item?.state,
                        district: item?.district,
                        revenueCircle: item?.revenueCircle,
                        vehicleId: vehicleList?.id,
                        registrationNo: vehicleList?.registrationNo,
                        vehicleType: vehicleList?.vehicleType,
                        vehicleCapacity: vehicleList?.vehicleCapacity,
                        vehicleMake: vehicleList?.vehicleMake,
                        vehicleModel: vehicleList?.vehicleModel,
                        vehicleMakeModel: vehicleList?.vehicleMakeModel,
                        routeName: rateCardDetails?.routeType,
                        transporterTableId: null,
                        route: null,
                        landId: null,
                        landName: null,
                        landType: null,
                        itemRate: null,
                        validFrom: null,
                        validTo: null,
                        background: null,
                        justification: null,
                        finalSummary: null,
                        documentName: null,
                        documentGuid: null,
                    }))
                }
                else if (rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") {
                    item?.routeList?.map((routeList) => arrayData.push({
                        id: uuidv4(),
                        category: rateCardDetails?.category,
                        itemType: rateCardDetails?.itemType,
                        unitPer: rateCardDetails?.unitPer,
                        urnNumber: item?.urn,
                        name: item?.name,
                        state: item?.state,
                        district: item?.district,
                        revenueCircle: item?.revenueCircle,
                        vehicleId: null,
                        registrationNo: null,
                        vehicleType: null,
                        vehicleCapacity: null,
                        vehicleMake: null,
                        vehicleModel: null,
                        vehicleMakeModel: null,
                        routeName: rateCardDetails?.routeType,
                        transporterTableId: routeList?.transporterTableId,
                        route: routeList?.fromName + " to " + routeList?.toName,
                        fromUrn: routeList?.fromUrn,
                        fromName: routeList?.fromName,
                        toUrn: routeList?.toUrn,
                        toName: routeList?.toName,
                        landId: null,
                        landName: null,
                        landType: null,
                        itemRate: null,
                        validFrom: null,
                        validTo: null,
                        background: null,
                        justification: null,
                        finalSummary: null,
                        documentName: null,
                        documentGuid: null,
                    }))
                }
                else if (rateCardDetails?.category === "Grower" && rateCardDetails?.itemType === "Bamboo Rate") {
                    item?.landDtlList?.map((landDtlList) => arrayData.push({
                        id: uuidv4(),
                        category: rateCardDetails?.category,
                        itemType: rateCardDetails?.itemType,
                        unitPer: rateCardDetails?.unitPer,
                        urnNumber: item?.urn,
                        name: item?.name,
                        state: landDtlList?.state,
                        district: landDtlList?.district,
                        revenueCircle: landDtlList?.revenueCircle,
                        vehicleId: null,
                        registrationNo: null,
                        vehicleType: null,
                        vehicleCapacity: null,
                        vehicleMake: null,
                        vehicleModel: null,
                        vehicleMakeModel: null,
                        routeName: null,
                        transporterTableId: null,
                        route: null,
                        landId: landDtlList?.landId,
                        landName: landDtlList?.landName,
                        landType: landDtlList?.landType,
                        itemRate: null,
                        validFrom: null,
                        validTo: null,
                        background: null,
                        justification: null,
                        finalSummary: null,
                        documentName: null,
                        documentGuid: null,
                    }))
                }
                else {
                    arrayData.push({
                        id: uuidv4(),
                        category: rateCardDetails?.category,
                        itemType: rateCardDetails?.itemType,
                        unitPer: rateCardDetails?.unitPer,
                        urnNumber: item?.urn,
                        name: item?.name,
                        state: item?.state,
                        district: item?.district,
                        revenueCircle: item?.revenueCircle,
                        vehicleId: null,
                        registrationNo: null,
                        vehicleType: null,
                        vehicleCapacity: null,
                        vehicleMake: null,
                        vehicleModel: null,
                        vehicleMakeModel: null,
                        routeName: rateCardDetails?.routeType,
                        transporterTableId: null,
                        route: null,
                        landId: null,
                        landName: null,
                        landType: null,
                        itemRate: null,
                        validFrom: null,
                        validTo: null,
                        background: null,
                        justification: null,
                        finalSummary: null,
                        documentName: null,
                        documentGuid: null,
                    })
                }
            }
            )
            setRateCardDetailsArr(arrayData);
        }
    }, [urnsList]);

    const handleExportExcel = (rows, columns, fileName) => {
        const displayedColumns = columns.filter((column) => column.hide !== true && column.field !== "actions");
        const worksheetData = rows.map((row) => {
            const data = {};
            displayedColumns.forEach((column) => {
                data[column.headerName] = row[column.field];
            });
            return data;
        });
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook, fileName);
    };


    const handleChangeFile = (e) => {
        setFileuploadError('');
        setSelectedFile(e.target.files[0])
    };

    const onConfirmSubmit = () => {
        handleConfirmLogModalClose();
        rateCardMassUpload();
    }

    const onSubmitFile = (e) => {
        if (selectedFile) {
            const extension = selectedFile.name.split('.').pop().toLowerCase();
            const isXlsFile = !!extension && extensionList.includes(extension);
            if (!isXlsFile) {
                setFileuploadError("Only .xls, .xlsx, .xlsm files are allowed.");
                return;
            }
            else if (selectedFile.name.split('.').length > 2) {
                setFileuploadError("Double extension file detected.");
                return;
            }
            else if (fileNameValidation(selectedFile.name)) {
                setFileuploadError(FILE_NAME_VALIDATION_ERROR);
                return;
            }
            else if (selectedFile.size >= 5000000) {
                setFileuploadError("The file size should be less than 5MB.");
                return;
            }
            else {
                handleConfirmLogModalOpen();
                e.preventDefault();
            }
        }
    };

    function rateCardMassUpload() {

        const formData = new FormData();

        formData.append("file", selectedFile);

        apiClient

            .post(RATE_CARD_MASS_ENTRY, formData, {

                headers: {

                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

                },

            })

            .then((response) => {

                setUploadDetails(response);

                // Navigate to previewRateCard.js with required state

                navigate("previewRateCard", {

                    state: {

                        //   uploadedRateCard: response?.data,
                        addedRateCardDetailsArr: response?.data?.rateList,  // Or whatever data you need
                        category: response?.data?.rateList[0]?.category
                    },

                });

            })

            .catch(function (error) {

                console.log(error);

                setUploadDetails(error?.response);

            });

    }


    const onProceedViewRateCardTable = (e) => {
        e.preventDefault();
        if (!rateCardDetails?.category) {
            setErrorMessage({ ...errorMessage, categoryError: CATEGORY_ERROR });
        }
        else if (!rateCardDetails?.itemType) {
            setErrorMessage({ ...errorMessage, itemTypeError: ITEM_TYPE_ERROR });
        }
        else if (!rateCardDetails?.validFromProceed) {
            setErrorMessage({ ...errorMessage, validFromProceedError: "Please select valid from date" });
        }
        else if (!rateCardDetails?.validToProceed) {
            setErrorMessage({ ...errorMessage, validToProceedError: "Please select valid to date" });
        }
        else if (!rateCardDetails?.state && rateCardDetails?.category === "Grower") {
            setErrorMessage({ ...errorMessage, stateError: STATE_ERROR });
        }
        else if (!rateCardDetails?.district && rateCardDetails?.category === "Grower") {
            setErrorMessage({ ...errorMessage, districtError: DISTRICT_ERROR });
        }
        else if (!rateCardDetails?.routeType && rateCardDetails?.category === "Transporter") {
            setErrorMessage({ ...errorMessage, routeTypeError: ROUTE_TYPE_ERROR });
        }
        else {
            getUrnsList(setUrnsList, rateCardDetails);
            setShowData(true);
        }
    }

    const onInsertItemRate = (e) => {
        const tempArr = ((rateCardDetailsArr).map(rateCardDetailsArrItem => {
            rateCardDetailsArrItem.itemRate = rateCardDetails?.itemRate
            rateCardDetailsArrItem.validFrom = rateCardDetails?.validFrom
            rateCardDetailsArrItem.validTo = rateCardDetails?.validTo
            return rateCardDetailsArrItem
        }
        ))
        setRateCardDetailsArr(tempArr);
        setFailedRateCardArr();
    }

    const handleEachChange = (e, item, type) => {
        setOnChangeFlag(true);
        const tempArr = ((rateCardDetailsArr).map(rateCardDetailsArrItem => {
            if (rateCardDetailsArrItem.urnNumber === item.urnNumber && rateCardDetailsArrItem.vehicleId === item.vehicleId && rateCardDetailsArrItem.transporterTableId === item.transporterTableId && rateCardDetailsArrItem.landId === item.landId) {
                if (type === "itemRateEach") {
                    const validatedAmount = validateAmount(e.target.value);
                    if (e.target.value === '') {
                        rateCardDetailsArrItem.itemRate = ''
                    }
                    if (validatedAmount) {
                        rateCardDetailsArrItem.itemRate = validatedAmount
                    }
                }
                if (type === "validFromEach") {
                    const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                    setFailedRateCardArr(tempArr);
                    rateCardDetailsArrItem.validFrom = e.format("YYYY-MM-DD")
                }
                if (type === "validToEach") {
                    const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                    setFailedRateCardArr(tempArr);
                    rateCardDetailsArrItem.validTo = e.format("YYYY-MM-DD")
                }
            }
            return rateCardDetailsArrItem
        }
        ))
        setRateCardDetailsArr(tempArr);
    }

    const [tempDistrict, setTempDistrict] = useState("")

    const handleChange = (e, item) => {
        setOnChangeFlag(true);
        if (e.target.name === "category") {
            setRateCardDetails({ ...rateCardDetails, category: e.target.value })
            setErrorMessage({ ...errorMessage, categoryError: "" });
        }
        if (e.target.name === "itemType") {
            setRateCardDetails({ ...rateCardDetails, itemType: e.target.value })
            setErrorMessage({ ...errorMessage, itemTypeError: "" });
        }
        if (e.target.name === "state") {
            getAllDistrict(e.target.value, setChooseDistrict);
            setRateCardDetails({ ...rateCardDetails, state: e.target.value })
            setErrorMessage({ ...errorMessage, stateError: "" });
        }
        if (e.target.name === "district") {
            setTempDistrict(e.target.value)
            if (addedRateCardDetailsArr.length !== 0) {
                handleDistrictLogModalOpen();
            }
            else {
                getAllRevenueCircle(e.target.value, setChooseRevenueCircle);
                setRateCardDetails({ ...rateCardDetails, district: e.target.value })
                setErrorMessage({ ...errorMessage, districtError: "" });
            }
        }
        if (e.target.name === "revenueCircle") {
            setRateCardDetails({ ...rateCardDetails, revenueCircle: e.target.value })
        }
        if (e.target.name === "validFromProceed") {
            // if(rateCardDetails.validToProceed < e.target.value) {
            //   setErrorMessage({ ...errorMessage, validFromProceedError: "Valid from date cannot be more than valid from date" });
            // }
            // else {
            setErrorMessage({ ...errorMessage, validFromProceedError: "" });
            // }
            setRateCardDetails({ ...rateCardDetails, validFromProceed: e.target.value })
        }
        if (e.target.name === "validToProceed") {
            // if(rateCardDetails.validFromProceed > e.target.value) {
            //   setErrorMessage({ ...errorMessage, validToProceedError: "Valid to date cannot be less than valid from date" });
            // }
            // else {
            setErrorMessage({ ...errorMessage, validToProceedError: "" });
            // }
            setRateCardDetails({ ...rateCardDetails, validToProceed: e.target.value })
        }
        if (e.target.name === "routeType") {
            setRateCardDetails({ ...rateCardDetails, routeType: e.target.value })
            setErrorMessage({ ...errorMessage, routeTypeError: "" });
        }
        if (e.target.name === "unitPer") {
            setRateCardDetails({ ...rateCardDetails, unitPer: e.target.value })
            setErrorMessage({ ...errorMessage, unitPerError: "" });
        }
        if (e.target.name === "itemRate") {
            const validatedAmount = validateAmount(e.target.value);
            if (e.target.value === '') {
                setRateCardDetails({ ...rateCardDetails, itemRate: '' })
            }
            if (validatedAmount) {
                setRateCardDetails({ ...rateCardDetails, itemRate: validatedAmount })
            }
        }
        if (e.target.name === "validFrom") {
            setRateCardDetails({ ...rateCardDetails, validFrom: e.target.value })
        }
        if (e.target.name === "validTo") {
            setRateCardDetails({ ...rateCardDetails, validTo: e.target.value })
        }
        if (item) {
            const tempArr = ((rateCardDetailsArr).map(rateCardDetailsArrItem => {
                if (rateCardDetailsArrItem.urnNumber === item.urnNumber && rateCardDetailsArrItem.vehicleId === item.vehicleId && rateCardDetailsArrItem.transporterTableId === item.transporterTableId && rateCardDetailsArrItem.landId === item.landId) {
                    if (e.target.name === "itemRateEach") {
                        rateCardDetailsArrItem.itemRate = e.target.value
                    }
                    if (e.target.name === "validFromEach") {
                        const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                        setFailedRateCardArr(tempArr);
                        rateCardDetailsArrItem.validFrom = e.target.value
                    }
                    if (e.target.name === "validToEach") {
                        const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                        setFailedRateCardArr(tempArr);
                        rateCardDetailsArrItem.validTo = e.target.value
                    }
                }
                return rateCardDetailsArrItem
            }
            ))
            setRateCardDetailsArr(tempArr);
        }
    }

    useEffect(() => {
        if (onChangeFlag) {
            let arrayData = [];
            rateCardDetailsArr?.map((item) =>
                item.itemRate && arrayData.push(item)
            )
            setFinalRateCardDetailsArr(arrayData);
        }
    }, [rateCardDetailsArr]);

    useEffect(() => {
        if (onChangeFlag) {
            setRateCardDetails({
                ...rateCardDetails,
                itemType: null,
                itemRate: null,
                validFromProceed: null,
                validToProceed: null,
                validFrom: null,
                validTo: null,
                unitPer: null,
                routeType: null,
                state: null,
                district: null,
                revenueCircle: null
            });
            setRateCardDetailsArr([]);
            setShowData(false);
            setUrnsList();
            setChooseDistrict([]);
        }
    }, [rateCardDetails.category]);

    useEffect(() => {
        if (onChangeFlag) {
            setRateCardDetails({
                ...rateCardDetails,
                itemRate: null,
                validFrom: null,
                validTo: null,
            });
            setRateCardDetailsArr([]);
            setShowData(false);
            setUrnsList();
        }
    }, [rateCardDetails.itemType, rateCardDetails.routeType, rateCardDetails.revenueCircle, rateCardDetails.validFromProceed, rateCardDetails.validToProceed]);

    useEffect(() => {
        if (onChangeFlag) {
            setRateCardDetails({
                ...rateCardDetails,
                itemRate: null,
                validFrom: null,
                validTo: null,
                district: null,
                revenueCircle: null
            });
            setShowData(false);
            setUrnsList();
        }
    }, [rateCardDetails.state]);

    useEffect(() => {
        if (onChangeFlag) {
            setRateCardDetails({
                ...rateCardDetails,
                itemRate: null,
                validFrom: null,
                validTo: null,
                revenueCircle: null
            });
            setShowData(false);
            setUrnsList();
        }
    }, [rateCardDetails.district]);

    useEffect(() => {
        if (onChangeFlag) {
            const tempArr = (rateCardDetailsArr?.map(item => {
                if (!addedRateCardDetailsArr?.includes(item)) {
                    item.unitPer = rateCardDetails.unitPer
                }
                return item
            }
            ))
        }
    }, [rateCardDetails?.unitPer]);

    useEffect(() => {
        if (filterTable.urnNumber || filterTable.name) {
            const filteredRateCardDetails = rateCardDetailsArr && rateCardDetailsArr?.filter(
                item => {
                    let keep = true;
                    if (filterTable.urnNumber) {
                        keep = keep && item.urnNumber?.toLowerCase()?.includes(filterTable?.urnNumber.toLowerCase().trim())
                    }
                    if (filterTable.name) {
                        keep = keep && item.name?.toLowerCase()?.includes(filterTable?.name.toLowerCase().trim())
                    }
                    return keep;
                }

            );
            setFilteredRateCardDetailsArr(filteredRateCardDetails);
        }
        else {
            setFilteredRateCardDetailsArr();
        }
    }, [filterTable.urnNumber, filterTable.name]);

    const onNext = (e) => {
        e.preventDefault();
        if (budgetApprovalRole?.budgetApproverFound === false) {
            toast.error("Budget approver role is not found!. Please, add budget approver role based on budget range")
        }
        else (addedRateCardDetailsArr?.length !== 0 && addedRateCardDetailsArr ? navigate('previewRateCard', { state: { rateCardDetailsArr: rateCardDetailsArr, addedRateCardDetailsArr: addedRateCardDetailsArr, finalRateCardDetailsArr: finalRateCardDetailsArr, urnsList: urnsList, category: rateCardDetails?.category, itemType: rateCardDetails?.itemType, unitPer: rateCardDetails?.unitPer, itemRate: rateCardDetails?.itemRate, validFrom: rateCardDetails?.validFrom, validTo: rateCardDetails?.validTo, state: rateCardDetails?.state, district: rateCardDetails?.district, revenueCircle: rateCardDetails?.revenueCircle, routeType: rateCardDetails?.routeType, budget: budgetApprovalRole } }) : setErrorMessage({ ...errorMessage, addItemError: "Please add item rate and then proceed" }))
    }

    const onAdd = (e) => {
        e.preventDefault();
        if (!rateCardDetails?.unitPer) {
            setErrorMessage({ ...errorMessage, unitPerError: UNIT_PER_ERROR });
        }
        else {
            const validityArr = finalRateCardDetailsArr?.filter(item => !addedRateCardDetailsArr?.includes(item))
            // fetchBudgetApprovalRole(setBudgetApprovalRole, validityArr);
            rateCardValidity(validityArr, setCheckValidityResponse);
        }
    };

    function onCancelBack() {
        handleDistrictLogModalClose();
    }

    function onConfirmCallBack() {
        handleDistrictLogModalClose();
        getAllRevenueCircle(tempDistrict, setChooseRevenueCircle);
        setRateCardDetails({ ...rateCardDetails, district: tempDistrict })
        setErrorMessage({ ...errorMessage, districtError: "" });
        setAddedRateCardDetailsArr([]);
        setFinalRateCardDetailsArr([]);
    }

    const excelColumns = [
        { field: 'category', headerName: "Category", width: 150 },
        { field: 'itemType', headerName: "Item Type", width: 150 },
        { field: 'urnNumber', headerName: STAKEHOLDER_URN, width: 500 },
        { field: 'name', headerName: STAKEHOLDER_NAME, width: 150 },
        { field: 'unitPer', headerName: "Unit Per", width: 150 },
        { field: 'registrationNo', headerName: REGISTRATION_NO, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleType', headerName: VEHICLE_TYPE, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleCapacity', type: "number", headerName: VEHICLE_CAPACITY, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleMake', headerName: VEHICLE_MAKE, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleModel', headerName: VEHICLE_MODEL, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleId', headerName: "Vehicle Id", width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        {
            field: 'state', headerName: STATE, width: 150, hide: rateCardDetails?.category !== "LLE" && rateCardDetails?.category !== "Grower",
            renderCell: (params) => {
                return (
                    params?.row?.state && titleCase(params?.row?.state)
                )
            }
        },
        {
            field: 'district', headerName: DISTRICT, width: 150, hide: rateCardDetails?.category !== "LLE" && rateCardDetails?.category !== "Grower",
            renderCell: (params) => {
                return (
                    params?.row?.district && titleCase(params?.row?.district)
                )
            }
        },
        // {
        //     field: 'revenueCircle', headerName: REVENUE_CIRCLE, width: 150, hide: rateCardDetails?.category !== "Grower",
        //     renderCell: (params) => {
        //         return (
        //             params?.row?.district && titleCase(params?.row?.district)
        //         )
        //     }
        // },
        { field: 'route', headerName: ROUTE, width: 150, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'routeName', headerName: "Route Name", width: 150, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'fromUrn', headerName: "From URN", width: 150, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'fromName', headerName: "From Name", width: 180, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'toUrn', headerName: "To URN", width: 150, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'toName', headerName: "To Name", width: 180, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'transporterTableId', headerName: "Transport Id", width: 150, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'landName', headerName: LAND_NAME, width: 150, hide: !(rateCardDetails?.category === "Grower" && rateCardDetails?.itemType === "Bamboo Rate") },
        { field: 'landId', headerName: "Land Id", width: 150, hide: !(rateCardDetails?.category === "Grower" && rateCardDetails?.itemType === "Bamboo Rate") },
        { field: 'validFrom', headerName: 'Valid From(yyyy-mm-dd)', width: 170, },
        { field: 'validTo', headerName: 'Valid To(yyyy-mm-dd)', width: 170 },
        {
            field: 'itemRate', headerName: ITEM_RATE, width: 150,
            renderCell: (params) => {
                return (
                    <TextField fullWidth
                        size="small"
                        label="Item Rate"
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                        value={params.row?.itemRate || ''}
                        onChange={(e) => handleEachChange(e, params.row, "itemRateEach")}
                    ></TextField>
                )
            }
        },
    ];

    const columns = [
        { field: 'urnNumber', headerName: STAKEHOLDER_URN, width: 150 },
        { field: 'name', headerName: STAKEHOLDER_NAME, width: 150 },
        { field: 'registrationNo', headerName: REGISTRATION_NO, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleType', headerName: VEHICLE_TYPE, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleCapacity', headerName: VEHICLE_CAPACITY, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleMake', headerName: VEHICLE_MAKE, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'vehicleModel', headerName: VEHICLE_MODEL, width: 150, hide: !(rateCardDetails?.category === "HIT" && rateCardDetails?.itemType === "Transportation Rate") },
        {
            field: 'state', headerName: STATE, width: 150, hide: rateCardDetails?.category !== "LLE",
            renderCell: (params) => {
                return (
                    params?.row?.state && titleCase(params?.row?.state)
                )
            }
        },
        {
            field: 'district', headerName: DISTRICT, width: 150, hide: rateCardDetails?.category !== "LLE",
            renderCell: (params) => {
                return (
                    params?.row?.district && titleCase(params?.row?.district)
                )
            }
        },
        { field: 'route', headerName: ROUTE, width: 150, hide: !(rateCardDetails?.category === "Transporter" && rateCardDetails?.itemType === "Transportation Rate") },
        { field: 'landName', headerName: LAND_NAME, width: 150, hide: !(rateCardDetails?.category === "Grower" && rateCardDetails?.itemType === "Bamboo Rate") },
        {
            field: 'validFrom', headerName: 'Valid From', width: 170,
            renderCell: (params) => {
                return (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Valid From"
                                inputFormat="DD/MM/YYYY"
                                value={params.row?.validFrom}
                                onChange={(newValue) => handleEachChange(newValue, params.row, "validFromEach")}
                                renderInput={(params) => <TextField {...params}
                                    size="small" />}
                                sx={{ minWidth: 750 }}
                            /></LocalizationProvider>
                    </>
                )
            }
        },
        {
            field: 'validTo', headerName: 'Valid To', width: 170,
            renderCell: (params) => {
                return (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Valid To"
                                inputFormat="DD/MM/YYYY"
                                minDate={params.row?.validFrom}
                                value={params?.row?.validTo}
                                onChange={(newValue) => handleEachChange(newValue, params.row, "validToEach")}
                                renderInput={(params) => <TextField {...params}
                                    size="small" />}
                                sx={{ minWidth: 750 }}
                            /></LocalizationProvider>
                    </>
                )
            }
        },
        {
            field: 'itemRate', headerName: ITEM_RATE, width: 150,
            renderCell: (params) => {
                return (
                    <TextField fullWidth
                        size="small"
                        label="Item Rate"
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                        value={params.row?.itemRate || ''}
                        onChange={(e) => handleEachChange(e, params.row, "itemRateEach")}
                    ></TextField>
                )
            }
        },
    ];

    useEffect(() => {

        if (uploadDetails) {

            if (uploadDetails?.data?.isSuccess === false) {

                toast.error(uploadDetails?.data?.description || "File upload failed");

            } else if (uploadDetails?.data?.isSuccess === true) {

                toast.success(uploadDetails?.data?.description || "File uploaded successfully");



                navigate('/previewRateCard', {

                    state: {

                        uploadedRateCard: uploadDetails?.data,

                        category: rateCardDetails?.category,

                        itemType: rateCardDetails?.itemType,

                        unitPer: rateCardDetails?.unitPer,

                        itemRate: rateCardDetails?.itemRate,

                        validFrom: rateCardDetails?.validFrom,

                        validTo: rateCardDetails?.validTo,

                        state: rateCardDetails?.state,

                        district: rateCardDetails?.district,

                        revenueCircle: rateCardDetails?.revenueCircle,

                        routeType: rateCardDetails?.routeType,

                    }

                });

            } else {

                toast.error(uploadDetails?.data?.description || "File upload failed");

            }

        }

    }, [uploadDetails]);


    return (
        <>
            <Container maxWidth="xxl">
                <pre>{JSON.stringify(filteredRateCardDetailsArr, null, 2)}</pre>
                {!PROD && <p className='pageNumberingResc'>RES16</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <BackButton navigate={navigate} />
                    <Typography variant="h5" gutterBottom>
                        Rate Card Mass Entry
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={3}>
                                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.category}>
                                    <InputLabel id="selectstakeholder-label">{CATEGORY}</InputLabel>
                                    <Select
                                        label={CATEGORY}
                                        name="category" value={rateCardDetails?.category || ''} onChange={(e) => handleChange(e)}>
                                        <MenuItem><em>{CATEGORY}</em></MenuItem>
                                        {
                                            categoryList?.filter(filterItem => filterItem !== "ABEPL Plant")?.map((item) =>
                                                <MenuItem value={item}>{item}</MenuItem>)
                                        }
                                    </Select>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage?.categoryError}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={3}>
                                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.itemType}>
                                    <InputLabel id="mappedstakeholder-label">{ITEM_TYPE}</InputLabel>
                                    <Select
                                        label={ITEM_TYPE}
                                        name="itemType" value={rateCardDetails?.itemType || ''} onChange={(e) => handleChange(e)}>
                                        <MenuItem><em>{ITEM_TYPE}</em></MenuItem>
                                        {rateCardDetails?.category && itemTypeList &&
                                            itemTypeList[rateCardDetails?.category]?.filter(item => item !== "Gate Price")?.map((item) =>
                                                <MenuItem value={item}>{item}</MenuItem>)
                                        }
                                    </Select>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage?.itemTypeError}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={2}>
                                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.validFromProceed}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Valid From"
                                            inputFormat="DD/MM/YYYY"
                                            value={rateCardDetails?.validFromProceed}
                                            onChange={(newValue) => setRateCardDetails({ ...rateCardDetails, validFromProceed: newValue.format("YYYY-MM-DD") })}
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                        /></LocalizationProvider>
                                    <FormHelperText sx={{ color: 'red' }}>{(rateCardDetails?.validFromProceed === null) ? errorMessage?.validFromProceedError : ''}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={2}>
                                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.validToProceed}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Valid To"
                                            inputFormat="DD/MM/YYYY"
                                            minDate={rateCardDetails?.validFromProceed}
                                            value={rateCardDetails?.validToProceed}
                                            onChange={(newValue) => setRateCardDetails({ ...rateCardDetails, validToProceed: newValue.format("YYYY-MM-DD") })}
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                        /></LocalizationProvider>
                                    <FormHelperText sx={{ color: 'red' }}>{(rateCardDetails?.validToProceed === null) ? errorMessage?.validToProceedError : ''}</FormHelperText>
                                </FormControl>
                            </Grid>
                            {(rateCardDetails?.category === null || rateCardDetails?.category === "LLE" || (rateCardDetails?.category === "Grower" && rateCardDetails?.itemType !== "Bamboo Rate") || rateCardDetails?.category === "InterimStorageOperator" || rateCardDetails?.category === "HIT") && <Grid item xs={12} lg={rateCardDetails?.category === "Transporter" ? 1 : 2}>
                                <Button sx={{ minWidth: 100 }} className="RescProceed" variant="contained" onClick={(e) => onProceedViewRateCardTable(e)}>{PROCEED}</Button>
                            </Grid>}
                        </Grid>
                        <Grid container spacing={1} sx={{ mt: 1 }}>
                            {(rateCardDetails?.category === "Transporter") &&
                                <Grid item xs={12} lg={3}>
                                    <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.routeType}>
                                        <InputLabel id="selectstakeholder-label">{ROUTE_TYPE}</InputLabel>
                                        <Select
                                            label={ROUTE_TYPE}
                                            name="routeType" value={rateCardDetails?.routeType || ''} onChange={(e) => handleChange(e)}>
                                            <MenuItem><em>{ROUTE_TYPE}</em></MenuItem>
                                            {routesList?.map((item) =>
                                                <MenuItem value={item}>{item}</MenuItem>)
                                            }
                                        </Select>
                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage?.routeTypeError}</FormHelperText>
                                    </FormControl>
                                </Grid>}
                            {rateCardDetails?.category === "Grower" && rateCardDetails?.itemType === "Bamboo Rate" &&
                                <>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.state}>
                                            <InputLabel id="mappedstakeholder-label">{STATE}</InputLabel>
                                            <Select
                                                label={STATE}
                                                name="state" value={rateCardDetails?.state || ''} onChange={(e) => handleChange(e)}>
                                                <MenuItem><em>{STATE}</em></MenuItem>
                                                {
                                                    chooseState?.map((statename) =>
                                                        <MenuItem value={statename}>{statename && titleCase(statename)}</MenuItem>)
                                                }
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage?.stateError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.district}>
                                            <InputLabel id="mappedstakeholder-label">{DISTRICT}</InputLabel>
                                            <Select
                                                label={DISTRICT}
                                                name='district' value={rateCardDetails?.district || ''} onChange={(e) => handleChange(e)}>
                                                <MenuItem><em>{DISTRICT}</em></MenuItem>
                                                {
                                                    chooseDistrict?.map((districtname) =>
                                                        <MenuItem value={districtname}>{districtname && titleCase(districtname)}</MenuItem>)
                                                }
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage?.districtError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                            <InputLabel id="mappedstakeholder-label">{REVENUE_CIRCLE}</InputLabel>
                                            <Select
                                                label={REVENUE_CIRCLE}
                                                name='revenueCircle' value={rateCardDetails?.revenueCircle || ''} onChange={(e) => handleChange(e)}>
                                                <MenuItem><em>Select</em></MenuItem>
                                                {
                                                    chooseRevenueCircle?.map((revenueCirclename) =>
                                                        <MenuItem value={revenueCirclename}>{titleCase(revenueCirclename)}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </>}
                            {(rateCardDetails?.category === "Transporter" || (rateCardDetails?.category === "Grower" && rateCardDetails?.itemType === "Bamboo Rate")) && <Grid item xs={12} md={6} lg={rateCardDetails?.category === "Transporter" ? 1 : 2}>
                                <Button endIcon={<ProceedIcon />} sx={{ minWidth: 100 }} className="RescProceed" variant="contained" onClick={(e) => onProceedViewRateCardTable(e)}>{PROCEED}</Button></Grid>}
                        </Grid>
                        <Grid container spacing={1} sx={{ mt: 1 }}>
                            {showData &&
                                <> <Grid item xs={12} lg={3}>
                                    <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.unitPer}>
                                        <InputLabel id="selectstakeholder-label">{UNIT_PER}</InputLabel>
                                        <Select
                                            label={UNIT_PER}
                                            name="unitPer" value={rateCardDetails?.unitPer || ''} onChange={(e) => handleChange(e)}>
                                            <MenuItem><em>{UNIT_PER}</em></MenuItem>
                                            {
                                                unitsList?.["unit per"]?.map((unitsList) =>
                                                    <MenuItem value={unitsList}>{unitsList}</MenuItem>)
                                            }
                                        </Select>
                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage?.unitPerError}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                    <Grid item xs={12} lg={2}>
                                        <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Valid From"
                                                    inputFormat="DD/MM/YYYY"
                                                    value={rateCardDetails?.validFrom}
                                                    onChange={(validfromValue) => setRateCardDetails({ ...rateCardDetails, validFrom: validfromValue.format("YYYY-MM-DD") })}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ minWidth: 750 }}
                                                /></LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={2}>
                                        <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Valid To"
                                                    minDate={rateCardDetails?.validFrom}
                                                    inputFormat="DD/MM/YYYY"
                                                    value={rateCardDetails?.validTo}
                                                    onChange={(validtoValue) => setRateCardDetails({ ...rateCardDetails, validTo: validtoValue.format("YYYY-MM-DD") })}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ minWidth: 750 }}
                                                /></LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={2}>
                                        <TextField fullWidth
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label="Item Rate"
                                            name="itemRate" value={rateCardDetails?.itemRate || ''} onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                            sx={{ paddingRight: '3%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={rateCardDetails?.category === "Transporter" ? 1 : 2}>
                                        <div className="resource-common-label-heading">&nbsp;</div>
                                        <p className="insert-button" onClick={(e) => onInsertItemRate(e)}>{INSERT_ALL}</p>
                                    </Grid>
                                </>}
                        </Grid>
                        {urnsList && showData ?
                            <>
                                <Grid container spacing={1} sx={{ mt: 0 }}>
                                    <Grid item xs={12} style={{ display: "flex", flexDirection: "row" }}>
                                        <Card>
                                            <CardContent>
                                                <label className="ChooseFileInputAdminPincode">
                                                    <input style={{ fontSize: '2vh' }} type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(e) => handleChangeFile(e)} name="Bulk_upload" />
                                                </label>
                                                <Button startIcon={<UploadIcon />} variant="contained" style={{ marginLeft: '2vh' }} onClick={(e) => onSubmitFile(e)}>Upload</Button>
                                                <Typography variant="subtitle2" fontSize="1.8vh" color="green">(upload only .xls, .xlsx, .xlsm files.File size limit=5MB)</Typography>
                                                <Typography variant="subtitle2" fontSize="1.8vh" color="red">{fileuploadError}</Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                                <Button style={{ display: "flex", flexDirection: "row", marginTop: "2vh" }} onClick={() => handleExportExcel(rateCardDetailsArr, excelColumns, `RateCard_${rateCardDetails.category}_${rateCardDetails.itemType}.xlsx`)}>
                                    <DownloadIcon /> <Typography variant="subtitle1">Download Rate Card Template.</Typography></Button>
                                <DataGrid autoHeight sx={{
                                    height: 430, width: '100%',
                                    '& .themeSuccess': {
                                        backgroundColor: '#FFFFFF'
                                    },
                                    '& .themeFailure': {
                                        backgroundColor: '#FF7F7F',
                                        color: '#1a3e72',
                                    },
                                }}
                                    rows={(filteredRateCardDetailsArr ? filteredRateCardDetailsArr : rateCardDetailsArr)?.filter(addedItem => !addedRateCardDetailsArr?.includes(addedItem))}
                                    columns={columns}
                                    pageSize={3}
                                    getCellClassName={(params) => {
                                        return failedRateCardArr?.includes(params?.row) ? 'themeFailure' : 'themeSuccess';
                                    }}
                                /></>
                            :
                            <></>
                        }

                        <Grid item xs={12} lg={12} display='flex' justifyContent="flex-end">
                            {urnsList && showData &&
                                <><Button endIcon={<ProceedIcon />} sx={{ minWidth: 100, mt: 2 }}
                                    variant="contained" onClick={(e) => onNext(e)} >Next</Button>
                                    <Button endIcon={<startIcon />} sx={{ minWidth: 100, mt: 2, ml: 2 }}
                                        variant="contained" value='add' onClick={(e) => onAdd(e)}>Add</Button></>
                            }
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
            <DistrictChangePopover onOpen={distrcitLogModalOpen} onConfirm={onConfirmCallBack} onClose={onCancelBack} />
            <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmSubmit} onClose={handleConfirmLogModalClose} action="Submit" />

        </>
    );
}
export default RateCardMassEntry;
